import * as React from "react";
import DisplayFormSectionQualifierPDF from "./DisplayFormSectionQualifierPDF";
import DisplayFormQualifierAttribute from "./DisplayFormQualifierAttributePDF";
import { IFormSectionPresentationModel } from "../../../../presenter/form/model/FormSectionPresentationModel";
import { IReferenceValue } from "../../../../model/form/ReferenceValue";
import { IFormInputValueValidationError } from "../../../../model/validation/FormInputValueValidationError";
import { IFormSectionQualifierPresentationModel } from "../../../../presenter/form/model/FormSectionQualifierPresentationModel";
import { IFormQualifierAttributePresentationModel } from "../../../../presenter/form/model/FormQualifierAttributePresentationModel";
import { IFormInputValuePresentationModel } from "../../../../presenter/form/model/FormInputValuePresentationModel";
import { Text, View, Font } from "@react-pdf/renderer";
import { AttributeFormConstants } from "../../../../common/Constants";
import NumberFormatter from "../../../../model/common/NumberFormatter";
import { DateService } from "../../../../service/DateService";
import { Date2Utils } from "../../../../common/utils/Date2Utils";
import { IFormQualifierAttribute } from "../../../../model/form/FormQualifierAttribute";
import SagoeUi from "../../../assets/fonts/623c7118249e082fe87a78e08506cb4b.ttf";
import SagoeUiBold from "../../../assets/fonts/60570a3f64a1fece44ebf71b43617029.ttf";

export interface State {}

export interface Props {
  formSection: IFormSectionPresentationModel;
  translate: any;
  getReferenceValues?: any;
  referenceLoading?: boolean;
  referenceValueList?: IReferenceValue[];
  parentFormSection?: IFormSectionPresentationModel;
  isEditableForm: boolean;
  addRow?: any;
  deleteRow?: any;
  changeFormAttribute?: any;
  validationErrors?: IFormInputValueValidationError[];
  formQualifierValidationErrors?: number[];
  styles: any;
  isPortal: boolean;
}

export default class DisplayFormSectionPDF extends React.Component<
  Props,
  State
> {
  getDate2Value = (value?: string) => {
    const { translate } = this.props;

    if (value && value.length !== 0) {
      const { month, year } = Date2Utils().parseDate2(value);
      if (month) {
        return `${translate(`months.${month}`)} ${year}`;
      }
      return year;
    }
    return "";
  };

  render() {
    const {
      formSection,
      translate,
      getReferenceValues,
      referenceLoading,
      referenceValueList,
      parentFormSection,
      isEditableForm,
      addRow,
      deleteRow,
      changeFormAttribute,
      validationErrors,
      formQualifierValidationErrors,
      styles,
      isPortal
    } = this.props;

    const sortFormSectionQualifiersByOrderNumber = (
      formSectionQualifiers: IFormSectionQualifierPresentationModel[]
    ) => {
      return formSectionQualifiers.sort((a, b) => {
        return a.orderNumber - b.orderNumber;
      });
    };
    const sortAttributesByOrderNumberInsertDisplay = (
      formQualifierAttributes: IFormQualifierAttributePresentationModel[]
    ) => {
      return formQualifierAttributes.sort((a, b) => {
        return a.orderNumberInsertDisplay - b.orderNumberInsertDisplay;
      });
    };

    const sortFormInputValuesByFormAttributeId = (
      formInputValues: IFormInputValuePresentationModel[]
    ) => {
      return formInputValues.sort((a, b) => {
        return a.formAttributeId - b.formAttributeId;
      });
    };

    const renderFormSubsections = () => {
      let formSubsectionRenderList: JSX.Element[] = [];
      if (formSection.subsections) {
        formSection.subsections.sort((a, b) => {
          return a.orderNumber - b.orderNumber;
        });
        formSection.subsections.forEach((subsection) => {
          formSubsectionRenderList.push(
            <DisplayFormSectionPDF
              key={`pdf-subsection-${subsection.id}`}
              formSection={subsection}
              translate={translate}
              getReferenceValues={getReferenceValues}
              referenceLoading={referenceLoading}
              referenceValueList={referenceValueList}
              parentFormSection={formSection}
              isEditableForm={isEditableForm}
              addRow={addRow}
              deleteRow={deleteRow}
              changeFormAttribute={changeFormAttribute}
              validationErrors={validationErrors}
              formQualifierValidationErrors={formQualifierValidationErrors}
              styles={styles}
              isPortal={isPortal}
            />
          );
        });
      }
      return formSubsectionRenderList;
    };

    const renderFormSectionQualifiersInline = (
      formSection: IFormSectionPresentationModel
    ) => {
      let qualifierRenderList: JSX.Element[] = [];
      if (formSection.qualifiers) {
        let sortedFormSectionQualifiers =
          sortFormSectionQualifiersByOrderNumber(formSection.qualifiers);

        sortedFormSectionQualifiers.forEach((qualifier) => {
          qualifier.formSection = formSection;
          qualifierRenderList.push(
            <DisplayFormSectionQualifierPDF
              key={qualifier.formSectionQualifierId}
              formSectionQualifier={qualifier}
              parentSection={formSection}
              translate={translate}
              getReferenceValues={getReferenceValues}
              referenceLoading={referenceLoading}
              referenceValueList={referenceValueList}
              isEditableForm={isEditableForm}
              changeFormAttribute={changeFormAttribute}
              validationErrors={validationErrors}
              formTypeCode={formSection.formTypeCode}
              formQualifierValidationErrors={formQualifierValidationErrors}
              styles={styles}
            />
          );
        });
      }
      return qualifierRenderList;
    };

    const checkFormSectionQualifierValidationError = (
      formSectionQualifier: IFormSectionQualifierPresentationModel
    ) => {
      let error: boolean | undefined = false;
      formSectionQualifier.attributes?.forEach((attribute) =>
        attribute.values.forEach((value) => {
          if (formQualifierValidationErrors?.includes(value.formQualifierId)) {
            error = true;
          }
        })
      );
      return error;
    };

    const renderQualifierTitle = (
      formSectionQualifier: IFormSectionQualifierPresentationModel,
      error?: boolean
    ) => {
      return (
        <Text
          style={{
            margin: "auto",
            fontSize: 8,
            fontFamily: "Segoe UI"
          }}
        >
          {formSectionQualifier.labelVisible && formSectionQualifier.label
            ? formSectionQualifier.label
            : formSectionQualifier.qualifierName}
        </Text>
      );
    };

    const renderLabel = (
      attribute: IFormQualifierAttribute,
      isMultiAttributeQualifier: boolean
    ) => {
      const label = attribute.labelVisible
        ? attribute.name || attribute.attributeName
        : undefined;

      if (isMultiAttributeQualifier && label) {
        return <Text>{`${label}:\n`}</Text>;
      }
    };

    const renderValues = (values: any[]) => {
      let itemValues: JSX.Element[] = [];
      values.forEach(
        (valueItem: IFormInputValuePresentationModel, index: number) => {
          if (valueItem.value || valueItem.value === 0) {
            const attribute = valueItem.attribute;

            const isMultiAttributeQualifier = values.length > 1;

            let value: string;
            if (!valueItem.visible) {
              value = valueItem.value;
            } else if (
              valueItem.attribute.attributeType ===
                AttributeFormConstants.TYPE_VALUES.DATE ||
              valueItem.attribute.attributeType ===
                AttributeFormConstants.TYPE_VALUES.INITIAL_DATE
            ) {
              value = this.parseDate(valueItem.value);
            } else if (
              valueItem.attribute.attributeType ===
                AttributeFormConstants.TYPE_VALUES.NUMBER ||
              valueItem.attribute.attributeType ===
                AttributeFormConstants.TYPE_VALUES.INITIAL_NUMBER
            ) {
              value = NumberFormatter().formatReadOnlyValue(valueItem.value);
            } else if (
              valueItem.attribute.attributeType ===
              AttributeFormConstants.TYPE_VALUES.DATE_2
            ) {
              value = this.getDate2Value(valueItem.value);
            } else {
              value = valueItem.value;
            }

            if (
              valueItem.attribute.attributeType ===
                AttributeFormConstants.TYPE_VALUES.NUMBER ||
              valueItem.attribute.attributeType ===
                AttributeFormConstants.TYPE_VALUES.INITIAL_NUMBER
            ) {
              itemValues.push(
                <Text style={this.props.styles.tableCell} key={index}>
                  {renderLabel(attribute, isMultiAttributeQualifier)}
                  <Text
                    style={{ fontWeight: "bold", textAlign: "right" }}
                  >{`${value} \n`}</Text>
                </Text>
              );
            } else {
              itemValues.push(
                <Text style={this.props.styles.tableCell} key={index}>
                  {renderLabel(attribute, isMultiAttributeQualifier)}
                  <Text style={{ fontWeight: "bold" }}>{`${value} \n`}</Text>
                </Text>
              );
            }
          }
        }
      );
      return itemValues;
    };

    const renderQualifierCells = (
      formSectionQualifiers: any[],
      formSectionQualifierId: number,
      row: any,
      isAggregated: boolean,
      colIndex: number
    ) => {
      if (isAggregated && colIndex === 0) {
        return (
          <Text style={this.props.styles.tableCell}>
            <Text style={{ fontWeight: "bold" }}>
              {translate("form_details.total")}
            </Text>
          </Text>
        );
      }
      let formSectionQualifier = formSectionQualifiers.filter((qualifier) => {
        return (
          qualifier.props.attribute.values &&
          qualifier.props.attribute.values[0].formSectionQualifierId ===
            formSectionQualifierId
        );
      });
      let values = [];
      if (formSectionQualifier.length > 1) {
        formSectionQualifier.forEach((qualifier) => {
          Array.prototype.push.apply(values, [
            qualifier.props.attribute.values[row.key]
          ]);
        });

        return <View>{renderValues(values)}</View>;
      } else if (formSectionQualifier.length === 1) {
        return (
          <View>
            {formSectionQualifier[0].props.attribute.values &&
            formSectionQualifier[0].props.attribute.values[row.key] ? (
              renderValues([
                formSectionQualifier[0].props.attribute.values[row.key]
              ])
            ) : (
              <Text></Text>
            )}
          </View>
        );
      }
    };

    const renderFormSectionQualifiersGrid = (
      formSection: IFormSectionPresentationModel
    ) => {
      let columns: any[] = [];
      let rows: any[] = [];
      let tableConfiguration = {};
      const isAggregated = isPortal && formSection.portalAggregate;
      if (formSection.qualifiers && formSection.qualifiers.length !== 0) {
        let sortedFormSectionQualifiers =
          sortFormSectionQualifiersByOrderNumber(formSection.qualifiers);
        let qualifierValues: any[] = [];
        rows = getFormSectionQualifierGridRows(formSection);
        sortedFormSectionQualifiers.forEach(
          (
            formSectionQualifier: IFormSectionQualifierPresentationModel,
            columnIndex: number
          ) => {
            let error =
              checkFormSectionQualifierValidationError(formSectionQualifier);
            columns.push({
              title: renderQualifierTitle(formSectionQualifier, error),
              dataIndex: formSectionQualifier.formSectionQualifierId,
              key: formSectionQualifier.formSectionQualifierId,
              width: formSectionQualifier.width,
              className: error ? "form-qualifier-error" : undefined,
              render: (text: string, record: any, rowIndex: number) =>
                renderFormQualifierAttributes(formSectionQualifier, rowIndex)
            });
            Array.prototype.push.apply(
              qualifierValues,
              renderFormQualifierAttributes(formSectionQualifier, 0)
            );
          }
        );
        return (
          <View
            {...tableConfiguration}
            key={formSection.id}
            style={styles.table}
          >
            <View style={styles.tableRow}>
              {columns.map((item, index) => {
                return (
                  <View
                    key={index}
                    style={{
                      width: `${100 / columns.length}%`,
                      borderStyle: "solid",
                      borderWidth: 1,
                      borderTopWidth: 0,
                      backgroundColor: "#CDCDCD",
                      padding: 2
                    }}
                  >
                    {item.title}
                  </View>
                );
              })}
            </View>
            {rows && rows.length > 0 ? (
              rows.map((item, index) => {
                return (
                  <View key={index} style={styles.tableRow}>
                    {columns.map((col, index2) => {
                      return (
                        <View
                          key={index2}
                          style={{
                            width: `${100 / columns.length}%`,
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderTopWidth: 0,
                            padding: 3,
                            minHeight: 15
                          }}
                        >
                          {renderQualifierCells(
                            qualifierValues,
                            col.dataIndex,
                            item,
                            isAggregated,
                            index2
                          )}
                        </View>
                      );
                    })}
                  </View>
                );
              })
            ) : (
              <View style={styles.tableRow}>
                <View
                  style={{
                    width: `100%`,
                    borderStyle: "solid",
                    borderWidth: 1,
                    borderTopWidth: 0,
                    padding: 3,
                    minHeight: 15
                  }}
                >
                  <Text
                    style={{
                      fontSize: 8,
                      fontFamily: "Segoe UI",
                      padding: "0pt 5pt 0pt",
                      fontStyle: "italic",
                      textAlign: "center"
                    }}
                  >
                    {translate("form_details.no_rows")}
                  </Text>
                </View>
              </View>
            )}
          </View>
        );
      }
    };

    const renderFormQualifierAttributes = (
      formSectionQualifier: IFormSectionQualifierPresentationModel,
      rowIndex: number
    ) => {
      let attributeRenderList: JSX.Element[] = [];
      if (formSectionQualifier.attributes) {
        let sortedFormQualifierAttributes =
          sortAttributesByOrderNumberInsertDisplay(
            formSectionQualifier.attributes
          );
        sortedFormQualifierAttributes.forEach(
          (
            formQualifierAttribute: IFormQualifierAttributePresentationModel
          ) => {
            formQualifierAttribute.values =
              sortFormInputValuesByFormAttributeId(
                formQualifierAttribute.values
              );
            attributeRenderList.push(
              <DisplayFormQualifierAttribute
                key={formQualifierAttribute.id}
                translate={translate}
                attribute={formQualifierAttribute}
                getReferenceValues={getReferenceValues}
                referenceValueList={referenceValueList}
                isEditableForm={false}
                rowIndex={rowIndex}
                changeFormAttribute={changeFormAttribute}
                formTypeCode={formSection.formTypeCode}
                qualifierCode={formSectionQualifier.qualifierCode}
                width={formSectionQualifier.width}
                styles={styles}
                isParentQualifierMultiAttribute={
                  (formSectionQualifier.attributes?.length || 0) > 1
                }
              />
            );
          }
        );
      }
      return attributeRenderList;
    };

    const getFormSectionQualifierGridRows = (
      formSection: IFormSectionPresentationModel
    ) => {
      let rows: any[] = [];
      if (formSection.maxNumber !== -1) {
        for (let i = 0; i < formSection.maxNumber; i++) {
          rows.push({ key: i });
        }
      } else {
        let valuesLength = 0;
        formSection.qualifiers &&
          formSection.qualifiers.forEach((qualifier) => {
            qualifier.attributes &&
              qualifier.attributes.forEach((attribute) => {
                if (
                  attribute.values &&
                  attribute.values.length > valuesLength
                ) {
                  valuesLength = attribute.values.length;
                }
              });
          });
        for (let i = 0; i < valuesLength; i++) {
          rows.push({ key: i });
        }
      }
      return rows;
    };

    return (
      <View wrap={true}>
        {parentFormSection ? (
          <View>
            <Text style={styles.subheader}>{`${
              formSection.orderNumberVisible
                ? `${parentFormSection.orderNumber}.${formSection.orderNumber}`
                : ""
            } ${formSection.labelVisible ? formSection.label : ""}`}</Text>
          </View>
        ) : (
          <View>
            <Text style={styles.header}>
              {`${
                formSection.orderNumberVisible
                  ? `${formSection.orderNumber}.`
                  : ""
              } ${formSection.labelVisible ? formSection.label : ""}`}
            </Text>
          </View>
        )}

        {formSection.comment ? (
          <Text style={styles.comment}>{formSection.comment}</Text>
        ) : null}

        {formSection.subsections.length !== 0 && renderFormSubsections()}
        {formSection.maxNumber && formSection.maxNumber === 1
          ? renderFormSectionQualifiersInline(formSection)
          : renderFormSectionQualifiersGrid(formSection)}
      </View>
    );
  }
  parseDate = (date: Date) => {
    return DateService().formatDate(date);
  };
}

Font.register({
  family: "Segoe UI",
  fonts: [
    {
      src: SagoeUiBold,
      fontWeight: "bold"
    },
    { src: SagoeUi }
  ]
});
